define(["underscore","urijs","@bingads-webui-universal/primitive-utilities","jquery","stacktrace-js","bluebird"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__28__, __WEBPACK_EXTERNAL_MODULE__29__, __WEBPACK_EXTERNAL_MODULE__32__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__37__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(25);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AjaxStub", {
  enumerable: true,
  get: function get() {
    return _ajaxStub.AjaxStub;
  }
});
Object.defineProperty(exports, "AjaxEventHandler", {
  enumerable: true,
  get: function get() {
    return _ajaxEventHandler.AjaxEventHandler;
  }
});
Object.defineProperty(exports, "ErrorStub", {
  enumerable: true,
  get: function get() {
    return _errorStub.ErrorStub;
  }
});

var _ajaxStub = __webpack_require__(26);

var _ajaxEventHandler = __webpack_require__(33);

var _errorStub = __webpack_require__(35);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxStub = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _ajaxInterceptor = __webpack_require__(27);

var _defaultConfig = __webpack_require__(31);

var _ajaxStubSchema = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * AjaxStub class - Creates an ajax stub that can be used by Instrumentation to stub ajax calls
 */
var AjaxStub =
/*#__PURE__*/
function () {
  /**
   * @param {object} options - contains instrumentation and optionally stubOptions, AjaxEventhandler
   */
  function AjaxStub() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AjaxStub);

    this.stubOptions = _underscore.default.defaults(options.stubOptions || {}, _defaultConfig.defaultConfig.stubOptions);
    this.handler = options.eventHandler || _defaultConfig.defaultConfig.eventHandler; // create scenario for logging

    this.setupScenario(options.instrumentation);
    this.interceptor = new _ajaxInterceptor.AjaxInterceptor(this.stubOptions, this.handler, this.ajaxStubScenario);
  }

  _createClass(AjaxStub, [{
    key: "init",
    value: function init() {
      var _this = this;

      _underscore.default.each(this.stubOptions.objectsToStub, function (objectToStub) {
        _this.interceptor.intercept(objectToStub);
      });
    }
  }, {
    key: "setupScenario",
    value: function setupScenario(instr) {
      instr.addScenario(_ajaxStubSchema.schema);
      this.ajaxStubScenario = instr.ajaxStubScenario.create(instr.ScenarioContext);
    }
  }]);

  return AjaxStub;
}();

exports.AjaxStub = AjaxStub;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxInterceptor = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _urijs = _interopRequireDefault(__webpack_require__(28));

var _primitiveUtilities = __webpack_require__(29);

var _ajaxEventInterceptor = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// We only want one ajax intercept, however instrumentation can be created a second time
// e.g. after creating a CID during signup
var globalInterceptInstance = null;
/**
 * AjaxInterceptor - Provides functionality to intercept ajax calls
 */

var AjaxInterceptor =
/*#__PURE__*/
function () {
  /**
   * @param {object} stubOptions - stub options to be used in ajax logging
   * @param {object} eventHandler - handler for ajax events
   * @param {object} scenario - scenario to be used by the stub
   * @param {function} generateRid - optional: overwrites the function that generates an RID
   */
  function AjaxInterceptor(stubOptions, eventHandler, scenario, generateRid) {
    _classCallCheck(this, AjaxInterceptor);

    this.stubOptions = stubOptions;
    this.eventHandler = eventHandler;
    this.scenario = scenario;
    this.generateRid = generateRid || _primitiveUtilities.generateGuid;
  }
  /* eslint-disable no-param-reassign */


  _createClass(AjaxInterceptor, [{
    key: "intercept",
    value: function intercept(jQuery) {
      var _this = this;

      var originalAjax = jQuery.ajax;

      var intercept = function intercept(url, options) {
        options = options || {};

        if (_underscore.default.isObject(url)) {
          options = url;
        } else if (_underscore.default.isString(url)) {
          options.url = url;
        } // add requestId to url


        var requestId = _this.generateRid();

        if (_this.shouldAddRequestId(options.dataType, options.url)) {
          options.url = (0, _urijs.default)(options.url).setQuery('ReqId', requestId).toString();
        }

        var activity = _this.scenario.ajaxStubActivity.create();

        var ajaxEventInterceptor = new _ajaxEventInterceptor.AjaxEventInterceptor(options, requestId, _this.stubOptions, _this.eventHandler, activity);
        ajaxEventInterceptor.triggerEventInterceptors();
        return originalAjax.call(jQuery, options);
      };

      globalInterceptInstance = intercept;

      jQuery.ajax = function (url, options) {
        return globalInterceptInstance === intercept ? intercept(url, options) : originalAjax.call(jQuery, url, options);
      };
    }
  }, {
    key: "shouldAddRequestId",
    value: function shouldAddRequestId(dataType, url) {
      var urlInLowerCase = _underscore.default.isString(url) ? url.toLowerCase() : '';
      return _underscore.default.isString(url) && urlInLowerCase.indexOf('reqid') === -1 && (_underscore.default.isUndefined(dataType) || dataType !== 'script') && urlInLowerCase.indexOf('scripts/') === -1;
    }
  }]);

  return AjaxInterceptor;
}();

exports.AjaxInterceptor = AjaxInterceptor;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__28__;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__29__;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxEventInterceptor = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var event = {
  BEFORESEND: 'beforeSend',
  SUCCESS: 'success',
  COMPLETE: 'complete',
  ERROR: 'error'
};
/**
 * AjaxInterceptor - Intercepts ajax events (beforeSend, success, error, complete)
 */

var AjaxEventInterceptor =
/*#__PURE__*/
function () {
  /**
   * @param {object} options - options from ajax call
   * @param {object} requestId - request id
   * @param {object} stubOptions - stub options to be used in ajax logging
   * @param {object} eventHandler - handler for ajax events
   * @param {object} activity - activity to be used by the ajax logging calls
   */
  function AjaxEventInterceptor(options, requestId, stubOptions, eventHandler, activity) {
    _classCallCheck(this, AjaxEventInterceptor);

    this.options = options;
    this.requestId = requestId;
    this.stubOptions = stubOptions;
    this.eventHandler = eventHandler;
    this.activity = activity;
  }

  _createClass(AjaxEventInterceptor, [{
    key: "triggerEventInterceptors",
    value: function triggerEventInterceptors() {
      var pageTrackingId = _underscore.default.result(this.stubOptions, 'pageTrackingId');

      var ajaxContext = {
        stubOptions: this.stubOptions,
        url: this.options.url,
        requestId: this.requestId,
        pageTrackingId: pageTrackingId,
        requestResult: true,
        httpMethod: this.options.type,
        error: '',
        ajaxStartTime: 0,
        ajaxRenderStartTime: 0,
        entityCount: this.stubOptions.getPageSize(this.options.data),
        activity: this.activity
      };
      if (this.eventHandler.beforeSendHandler) this.interceptBeforeSend(this.options, ajaxContext);
      if (this.eventHandler.successHandler) this.interceptSuccess(this.options, ajaxContext);
      if (this.eventHandler.errorHandler) this.interceptError(this.options, ajaxContext);
      if (this.eventHandler.completeHandler) this.interceptComplete(this.options, ajaxContext);
    }
    /* eslint-disable no-param-reassign */

  }, {
    key: "interceptBeforeSend",
    value: function interceptBeforeSend(ajaxOptions, ajaxContext) {
      var context = this;

      if (_underscore.default.isUndefined(ajaxOptions[event.BEFORESEND])) {
        ajaxOptions[event.BEFORESEND] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          context.eventHandler.beforeSendHandler(ajaxContext, args);
        };
      } else if (_underscore.default.isFunction(ajaxOptions[event.BEFORESEND])) {
        var originalEventHandler = ajaxOptions[event.BEFORESEND];

        ajaxOptions[event.BEFORESEND] = function onBeforeSend() {
          var wrappedFunc = context.constructor.handleException(originalEventHandler, context.options.url, context.requestId, context.activity);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          var originalRet = wrappedFunc.apply(this, args);
          context.eventHandler.beforeSendHandler(ajaxContext, args);

          if (originalRet && _underscore.default.isFunction(originalRet.onBeforeSendDone)) {
            return originalRet.onBeforeSendDone(ajaxContext, args);
          }

          return originalRet;
        };
      }
    }
  }, {
    key: "interceptSuccess",
    value: function interceptSuccess(ajaxOptions, ajaxContext) {
      var context = this;

      if (_underscore.default.isUndefined(ajaxOptions[event.SUCCESS])) {
        ajaxOptions[event.SUCCESS] = function () {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          context.eventHandler.successHandler(ajaxContext, args);

          if (context.eventHandler.successRenderHandler) {
            context.eventHandler.successRenderHandler(ajaxContext, args);
          }
        };
      } else if (_underscore.default.isFunction(ajaxOptions[event.SUCCESS])) {
        var originalEventHandler = ajaxOptions[event.SUCCESS];

        ajaxOptions[event.SUCCESS] = function onSuccess() {
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          context.eventHandler.successHandler(ajaxContext, args);
          var wrappedFunc = context.constructor.handleException(originalEventHandler, context.options.url, context.requestId, context.activity);
          var originalRet = wrappedFunc.apply(this, args);

          if (context.eventHandler.successRenderHandler) {
            context.eventHandler.successRenderHandler(ajaxContext, args);
          }

          return originalRet;
        };
      }
    }
  }, {
    key: "interceptError",
    value: function interceptError(ajaxOptions, ajaxContext) {
      var context = this;

      if (_underscore.default.isUndefined(ajaxOptions[event.ERROR])) {
        ajaxOptions[event.ERROR] = function () {
          for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }

          context.eventHandler.errorHandler(ajaxContext, args);
        };
      } else if (_underscore.default.isFunction(ajaxOptions[event.ERROR])) {
        var originalEventHandler = ajaxOptions[event.ERROR];

        ajaxOptions[event.ERROR] = function onError() {
          for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
          }

          context.eventHandler.errorHandler(ajaxContext, args);
          var wrappedFunc = context.constructor.handleException(originalEventHandler, context.options.url, context.requestId, context.activity);
          var originalRet = wrappedFunc.apply(this, args);
          return originalRet;
        };
      }
    }
  }, {
    key: "interceptComplete",
    value: function interceptComplete(ajaxOptions, ajaxContext) {
      var context = this;

      if (_underscore.default.isUndefined(ajaxOptions[event.COMPLETE])) {
        ajaxOptions[event.COMPLETE] = function () {
          for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
          }

          context.eventHandler.completeHandler(ajaxContext, args);
        };
      } else if (_underscore.default.isFunction(ajaxOptions[event.COMPLETE])) {
        var originalEventHandler = ajaxOptions[event.COMPLETE];

        ajaxOptions[event.COMPLETE] = function onComplete() {
          var wrappedFunc = context.constructor.handleException(originalEventHandler, context.options.url, context.requestId, context.activity);

          for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            args[_key8] = arguments[_key8];
          }

          var originalRet = wrappedFunc.apply(this, args);
          context.eventHandler.completeHandler(ajaxContext, args);
          return originalRet;
        };
      }
    }
  }], [{
    key: "handleException",
    value: function handleException(func, api, requestId, activity, message) {
      return function wrappedFunc() {
        var context = this;
        var error = !_underscore.default.isUndefined(message) ? "".concat(message, ": ") : '';

        try {
          for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            args[_key9] = arguments[_key9];
          }

          return func.apply(context, args);
        } catch (ex) {
          if (!ex.message) {
            error += ex.toString();
          } else if (!ex.stack) {
            error += ex.message;
          } else {
            error += "".concat(ex.message, "\tStackTrace: ").concat(ex.stack);
          }

          activity.error(error, api, requestId);
          throw ex;
        }
      };
    }
  }]);

  return AjaxEventInterceptor;
}();

exports.AjaxEventInterceptor = AjaxEventInterceptor;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = void 0;

var _jquery = _interopRequireDefault(__webpack_require__(32));

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _ajaxEventHandler = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStubOptions = {
  objectsToStub: [_jquery.default],
  serverErrorCodes: [-1],
  detectError: function detectError(respData, serverErrorCodes) {
    var result = {
      pass: true
    };

    if (respData && respData.Errors && respData.Errors[0] && respData.Errors[0].Code && _underscore.default.isArray(serverErrorCodes) && _underscore.default.contains(serverErrorCodes, respData.Errors[0].Code)) {
      result.pass = false;
      result.message = respData.Errors[0].Message;
      result.impactUser = true;
    }

    return result;
  },
  getEntityCount: function getEntityCount(respData) {
    if (respData && respData.Records) {
      return respData.Records.RowCount;
    }

    return -1;
  },
  getPageSize: function getPageSize(requestData) {
    var pageSizeParam = '.PageSize';

    if (_underscore.default.isObject(requestData) && requestData.BiDateRange) {
      var keys = _underscore.default.keys(requestData);

      var pageSizeProp = _underscore.default.find(keys, function (key) {
        return key.length > pageSizeParam.length && key.substr(key.length - pageSizeParam.length) === pageSizeParam;
      });

      return requestData[pageSizeProp];
    }

    return -1;
  }
}; // default ajax event handler

var ajaxEventHandler = new _ajaxEventHandler.AjaxEventHandler();
var defaultConfig = {
  stubOptions: defaultStubOptions,
  eventHandler: ajaxEventHandler
};
exports.defaultConfig = defaultConfig;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__32__;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxEventHandler = void 0;

var _jquery = _interopRequireDefault(__webpack_require__(32));

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _primitiveUtilities = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable max-len */

/**
 * AjaxEventHandler - contains event handlers for ajax events (beforeSend, success, error, complete)
 * The consuming application can override the handlers here by extending from this base handler
 * and pass in a custom AjaxEventHandler when instantiating the AjaxStub
 */
var AjaxEventHandler =
/*#__PURE__*/
function () {
  function AjaxEventHandler() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AjaxEventHandler);

    this.errorMappers = options.errorMappers || [];
    this.shouldAddHeaders = options.shouldAddHeaders || _underscore.default.constant(true);
  }
  /**
   * Handler for the ajax beforeSend event.
   * @param {object} ajaxContext - data related to the current ajax call
   * @param {Array} args - args passed to the beforeSend ajax callback
   * @returns {undefined} - no returns
   */


  _createClass(AjaxEventHandler, [{
    key: "beforeSendHandler",
    value: function beforeSendHandler(ajaxContext, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          jqXHR = _ref2[0];

      /* eslint-disable no-param-reassign */
      ajaxContext.ajaxStartTime = (0, _primitiveUtilities.getTimestamp)();

      if (this.shouldAddHeaders(ajaxContext) === true) {
        var applicationName = _underscore.default.result(ajaxContext.stubOptions.ajaxStubOptions, 'applicationName', 'bingadsweb');

        jqXHR.setRequestHeader('x-ms-requestid', ajaxContext.requestId); // eslint-disable-next-line no-unused-expressions

        ajaxContext.pageTrackingId && jqXHR.setRequestHeader('x-ms-pagetrackingid', ajaxContext.pageTrackingId);
        jqXHR.setRequestHeader('x-ms-applicationname', applicationName);
        jqXHR.setRequestHeader('x-ms-lcid', ajaxContext.stubOptions.lcid);
        jqXHR.setRequestHeader('lcid', ajaxContext.stubOptions.lcid);
      }

      ajaxContext.activity.ajax(ajaxContext.requestId, ajaxContext.url, true, ajaxContext.httpMethod, 0, true, '', ajaxContext.entityCount);
    }
    /**
     * Handler for the ajax success event.
     * @param {object} ajaxContext - data related to the current ajax call
     * @param {Array} args - args passed to the success ajax callback
     * @returns {undefined} - no returns
     */

  }, {
    key: "successHandler",
    value: function successHandler(ajaxContext, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 3),
          data = _ref4[0],
          textStatus = _ref4[1],
          jqXHR = _ref4[2];

      // eslint-disable-line no-unused-vars
      var ajaxTimeTaken = (0, _primitiveUtilities.getTimestamp)() - ajaxContext.ajaxStartTime;
      var result = ajaxContext.stubOptions.detectError(data);

      if (!result.pass) {
        ajaxContext.requestResult = false;
        ajaxContext.error = result.message;
        ajaxContext.activity.error(ajaxContext.error, ajaxContext.url, ajaxContext.requestId, result.impactUser, ajaxContext.httpMethod);
      }

      ajaxContext.activity.ajax(ajaxContext.requestId, ajaxContext.url, false, ajaxContext.httpMethod, ajaxTimeTaken, ajaxContext.requestResult, this.constructor.getServerPerf(jqXHR), ajaxContext.entityCount);
      ajaxContext.entityCount = ajaxContext.stubOptions.getEntityCount(data);
      ajaxContext.ajaxRenderStartTime = (0, _primitiveUtilities.getTimestamp)();
    }
    /**
     * Handler to execute after the ajax success callback.
     * It's only purpose is to measure ajaxRender time.
     * @param {object} ajaxContext - data related to the current ajax call
     * @returns {undefined} - no returns
     */

  }, {
    key: "successRenderHandler",
    value: function successRenderHandler(ajaxContext) {
      if (ajaxContext.requestResult === true) {
        var renderTimeTaken = (0, _primitiveUtilities.getTimestamp)() - ajaxContext.ajaxRenderStartTime;
        ajaxContext.activity.ajax(ajaxContext.requestId, ajaxContext.url, false, ajaxContext.httpMethod, renderTimeTaken, ajaxContext.requestResult, '', ajaxContext.entityCount, true);
      }
    }
    /**
     * Handler for the ajax error event.
     * This may need to be overriden by the application to handle expected errors.
     * @param {object} ajaxContext - data related to the current ajax call
     * @param {Array} args - args passed to the error ajax callback
     * @returns {undefined} - no returns
     */

  }, {
    key: "errorHandler",
    value: function errorHandler(ajaxContext, _ref5) {
      var _ref6 = _slicedToArray(_ref5, 3),
          jqXHR = _ref6[0],
          textStatus = _ref6[1],
          errorThrown = _ref6[2];

      var ajaxTimeTaken = (0, _primitiveUtilities.getTimestamp)() - ajaxContext.ajaxStartTime;

      if (jqXHR.status !== 0) {
        ajaxContext.requestResult = false;
        ajaxContext.error = "Ajax error [".concat(jqXHR.status, "]");

        if (textStatus && _jquery.default.trim(textStatus) !== '') {
          ajaxContext.error += ", ".concat(textStatus); // Log jqXHR.responseText when it is not 200 (which means will enter errorHandler)

          if (jqXHR.responseText && _jquery.default.trim(jqXHR.responseText) !== '') {
            ajaxContext.error += ", ".concat(jqXHR.responseText);
          } else if (jqXHR.responseXML && _jquery.default.trim(jqXHR.responseXML) !== '') {
            ajaxContext.error += ", ".concat(jqXHR.responseXML);
          }
        }

        if (errorThrown && _jquery.default.trim(errorThrown) !== '') {
          ajaxContext.error += ", ".concat(errorThrown);
        }

        switch (jqXHR.status) {
          case 400:
          case 404:
            // If error maps to a user error, log at trace level
            if (this.isUserError(ajaxContext, jqXHR, textStatus, errorThrown)) {
              ajaxContext.requestResult = true;
            }

            break;

          case 401:
            // Log 401 unauthorized error at trace level
            ajaxContext.requestResult = true;
            break;

          default:
            ajaxContext.requestResult = false;
        }

        if (ajaxContext.requestResult === false) {
          ajaxContext.activity.error(ajaxContext.error, ajaxContext.url, ajaxContext.requestId, '', ajaxContext.httpMethod);
        } else {
          ajaxContext.activity.trace(ajaxContext.error, ajaxContext.url, ajaxContext.requestId, ajaxContext.httpMethod);
        }
      }

      ajaxContext.activity.ajax(ajaxContext.requestId, ajaxContext.url, false, ajaxContext.httpMethod, ajaxTimeTaken, ajaxContext.requestResult);
    }
    /**
     * Handler for the ajax complete event.
     * @param {object} ajaxContext - data related to the current ajax call
     * @param {Array} args - args passed to the beforeSend ajax callback
     * @returns {undefined} - no returns
     */

  }, {
    key: "completeHandler",
    value: function completeHandler(ajaxContext, _ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
          jqXHR = _ref8[0];
    } // eslint-disable-line no-unused-vars
    // do nothing

    /**
     * private method to check if ajax error maps to an user error
     * @param {object} ajaxContext - data related to the current ajax call
     * @param {object} jqXHR - jqXHR passed to the ajax callback
     * @param {object} textStatus - textStatus passed to the ajax callback
     * @param {object} errorThrown - errorThrown passed to the ajax callback
     * @returns {bool} - if error is an user error
     */

  }, {
    key: "isUserError",
    value: function isUserError(ajaxContext, jqXHR, textStatus, errorThrown) {
      return _underscore.default.any(this.errorMappers, function (errorMapper) {
        return errorMapper.check(ajaxContext, jqXHR, textStatus, errorThrown);
      });
    }
  }], [{
    key: "getServerPerf",
    value: function getServerPerf(jqXHR) {
      if (jqXHR && _underscore.default.isFunction(jqXHR.getResponseHeader)) {
        var perfTimings = jqXHR.getResponseHeader('PerfTimings');

        if (perfTimings) {
          return perfTimings;
        }

        var odataPerf = {};

        _underscore.default.each(['x-ms-mte2eelapsedtimems', 'x-ms-odataapie2eelapsedtimems', 'x-ms-odataapionlye2eelapsedtimems'], function (header) {
          var value = jqXHR.getResponseHeader(header);

          if (value) {
            odataPerf[header] = value;
          }
        });

        if (jqXHR.responseJSON) {
          var key = '@ns.cacheobjectused';
          odataPerf[key] = jqXHR.responseJSON[key];
          var keyUnfilteredCount = '@ns.unfiltered.count';
          odataPerf[keyUnfilteredCount] = jqXHR.responseJSON[keyUnfilteredCount];
          var keyOdataCount = '@odata.count';
          odataPerf[keyOdataCount] = jqXHR.responseJSON[keyOdataCount];
        }

        return JSON.stringify(odataPerf);
      }

      return '';
    }
  }]);

  return AjaxEventHandler;
}();

exports.AjaxEventHandler = AjaxEventHandler;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = void 0;

/**
 * Pre-defined schema used for Ajax Stub
 */
var schema = {
  scenario: [{
    name: 'ajaxStubScenario',
    value: 'Ajax Stub Scenario',
    setting: {
      hidden: true
    },
    activity: [{
      name: 'ajaxStubActivity',
      value: 'Ajax Stub Activity',
      setting: {}
    }]
  }]
};
exports.schema = schema;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorStub = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _stacktraceJs = _interopRequireDefault(__webpack_require__(36));

var _bluebird = _interopRequireDefault(__webpack_require__(37));

var _errorStubSchema = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function getStackStringFromStackFrames(stackFrames) {
  var stackLines = _underscore.default.map(stackFrames, function (frame) {
    return [frame.getFunctionName() || '<anonymous>', ' (', frame.getFileName(), ':', frame.getLineNumber(), ':', frame.getColumnNumber(), ')'].join('');
  }).join('\n');

  return stackLines;
}
/**
 * ErrorStub class - Creates a window.onerror stub that can be used by Instrumentation
 */


var ErrorStub =
/*#__PURE__*/
function () {
  /**
   * @param {object} options - contains instrumentation for logging
   */
  function ErrorStub() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ErrorStub);

    // create scenario for logging
    this.setupScenario(options.instrumentation);
    this.logUnhandledPromiseRejections = options.logUnhandledPromiseRejections || false;
    this.isExpectedUnhandledPromiseError = options.isExpectedUnhandledPromiseError;
  }

  _createClass(ErrorStub, [{
    key: "init",
    value: function init() {
      this.intercept();
    }
  }, {
    key: "intercept",
    value: function intercept() {
      var _this = this;

      window.onerror = function (errorMsg, url, lineNumber, column, errorObj) {
        var activity = _this.errorStubScenario.errorStubActivity.create();

        _this.handleError(errorMsg, url, lineNumber, column, errorObj, activity);

        return true;
      };

      if (this.logUnhandledPromiseRejections) {
        window.addEventListener('unhandledrejection', function (promiseRejection) {
          var activity = _this.errorStubScenario.errorStubActivity.create();

          _this.handlePromiseRejection(promiseRejection, activity);
        });
      }
    }
  }, {
    key: "handleError",
    value: function handleError(errorMsg, url, lineNumber, column, errorObj, activity) {
      var errorMessage = "".concat(errorMsg, "\tScript: ").concat(url, " Line: ").concat(lineNumber);

      if (!_underscore.default.isUndefined(column)) {
        errorMessage += " Column: ".concat(column);
      }

      return _stacktraceJs.default.fromError(errorObj).then(function (stackFrames) {
        errorMessage += " StackTrace: ".concat(getStackStringFromStackFrames(stackFrames));
      }).catch(function (ex) {
        if (_underscore.default.isObject(errorObj) && _underscore.default.has(errorObj, 'stack')) {
          errorMessage += " StackTrace: ".concat(errorObj.stack, "\n [StackTrace Error: ").concat(ex, "]");
        }
      }).finally(function () {
        errorMessage += "\tCurrentURL: ".concat(window.location.href, "\tPreviousURL: ").concat(document.referrer ? document.referrer : 'Unknown');
        var perviousRoute = window.history.state && window.history.state.state ? window.history.state.state.previousRoute : null;

        if (perviousRoute) {
          errorMessage += "\tPreviousRoute: ".concat(perviousRoute);
        }

        activity.error(errorMessage, 'onerror');
      });
    }
  }, {
    key: "handlePromiseRejection",
    value: function handlePromiseRejection(promiseRejectionEvent, activity) {
      var errorMessage = 'Unhandled promise rejection;'; // Bluebird stores these properties in .detail while native promise stores these properties at top level

      var _ref = promiseRejectionEvent.detail || promiseRejectionEvent,
          promise = _ref.promise,
          reason = _ref.reason;

      var isExpectedUnhandledPromiseError = this.isExpectedUnhandledPromiseError; // Reason is an Error-like object

      if (reason && (reason.message || reason.stack)) {
        var message = reason.message,
            stack = reason.stack;
        return _stacktraceJs.default.fromError(reason).then(function (stackFrames) {
          errorMessage += " Message: ".concat(message, "; StackTrace: ").concat(getStackStringFromStackFrames(stackFrames));
        }).catch(function (ex) {
          errorMessage += "".concat(message, " at ").concat(stack, "\n [StackTrace Error: ").concat(ex, "]");
        }).finally(function () {
          if (isExpectedUnhandledPromiseError && isExpectedUnhandledPromiseError(errorMessage)) {
            activity.trace(errorMessage, 'onunhandledrejection');
          } else {
            activity.error(errorMessage, 'onunhandledrejection');
          }
        });
      } // Use bluebird's stack trace if available


      errorMessage += "Non error object thrown; Reason: ".concat(JSON.stringify(reason), "; StackTrace: ").concat(_underscore.default.get(promise, '_trace.stack'), ";");

      if (isExpectedUnhandledPromiseError && isExpectedUnhandledPromiseError(errorMessage)) {
        activity.trace(errorMessage, 'onunhandledrejection');
      } else {
        activity.error(errorMessage, 'onunhandledrejection');
      }

      return _bluebird.default.resolve();
    }
  }, {
    key: "setupScenario",
    value: function setupScenario(instr) {
      instr.addScenario(_errorStubSchema.schema);
      this.errorStubScenario = instr.errorStubScenario.create(instr.ScenarioContext);
    }
  }]);

  return ErrorStub;
}();

exports.ErrorStub = ErrorStub;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__37__;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = void 0;

/**
 * Pre-defined schema used for Error Stub
 */
var schema = {
  scenario: [{
    name: 'errorStubScenario',
    value: 'Error Stub Scenario',
    setting: {
      hidden: true
    },
    activity: [{
      name: 'errorStubActivity',
      value: 'Error Stub Activity',
      setting: {}
    }]
  }]
};
exports.schema = schema;

/***/ })
/******/ ])});;
